const { ClipLoader } = require('react-spinners');

const Loader = () => (
  <div style={{ textAlign: 'center' }}>
    <ClipLoader />
  </div>
);

export default Loader;
